import React, { useState } from 'react';
import { Typography, Stack, Button, TextField, InputAdornment, useTheme, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { buttonStyle3 } from '../utils/commonStyle';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import HeaderDropDownMenu from './HeaderDropDownMenu';
import { useCallback } from 'react';
import { debounce } from "lodash";

export default function PageHeader({ children, headerTittle, userPermission, menus, handleOnSelectEmit, handleOnSearchEmit, handleExcelDownloadEmit, handleOnAddEmit, buttonShowPermission, menuButtonName = 'Actions', placeholder, searchBarWidth, tableType, headerColor, showCloseBtn = false, handleClose }) {
  const theme = useTheme();
  const [search, setSearch] = useState('');

  const request = debounce(tempValue => {
    handleOnSearchEmit(tempValue ? tempValue : null);
  }, 400);

  const debouceRequest = useCallback(value => request(value), []);

  const handleOnChange = (event) => {
    setSearch(event.target.value.trimStart());
    debouceRequest(event.target.value.trimStart());
  };

  return (
    <>
      <div style={{ backgroundColor: headerColor ? headerColor : '#FFFFFF' }}>
        <header className="mb-[8px]">
          {tableType === '2' ? (
            <>
              <Stack
                className={tableType === '2' ? 'pt-[5px] pl-[10px]' : ''}
                direction={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
                flex={1}
              >
                <Stack flex={1}>{children}</Stack>
                <Stack
                  direction={'row'}
                  className="ml-[10px]"
                >
                  <TextField
                    className={[!showCloseBtn ? '!mr-[16px]' : '', tableType === '2' ? '!mt-[5px]' : '']}
                    placeholder={null}
                    id="search"
                    name="search"
                    value={search || ''}
                    onChange={handleOnChange}
                    size="small"
                    sx={{
                      maxWidth: searchBarWidth ? searchBarWidth : '355px',
                      minWidth: searchBarWidth ? searchBarWidth : '355px',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        '& input::placeholder': {
                          fontSize: '10px',
                        },
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          disablePointerEvents
                          position="end"
                        >
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  {showCloseBtn && (
                    <IconButton
                      sx={{
                        ml: 0,
                      }}
                    >
                      <ClearIcon
                        style={{ transform: 'scale(1)', color: 'rgba(255, 255, 255,0.5)' }}
                        onClick={() => {
                          handleClose();
                        }}
                      />
                    </IconButton>
                  )}
                </Stack>
              </Stack>
            </>
          ) : (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems={'center'}
            >
              <Typography
                className="ff-Roboto fw-medium !text-[16px] !uppercase"
                style={{ color: '#14285A', marginLeft: '20px' }}
              >
                {headerTittle}
              </Typography>
              <div className="items-center flex">
                <TextField
                  className="!mr-[16px]"
                  placeholder={placeholder}
                  id="search"
                  name="search"
                  value={search || ''}
                  onChange={handleOnChange}
                  size="small"
                  sx={{
                    maxWidth: searchBarWidth ? searchBarWidth : '355px',
                    minWidth: searchBarWidth ? searchBarWidth : '355px',
                    '& .MuiOutlinedInput-root': {
                      //   borderRadius: 16,
                      '& input::placeholder': {
                        fontSize: '10px',
                      },
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        disablePointerEvents
                        position="end"
                      >
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                {buttonShowPermission?.excelDownload ? (
                  <Button
                    className="!mr-[16px] !capitalize"
                    sx={buttonStyle3}
                    style={{ backgroundColor: buttonShowPermission?.excelIsDisabled ? theme.palette.primaryDark.secondary : theme.palette.primaryDark.main, color: 'rgba(255, 255, 255, 1)' }}
                    disabled={buttonShowPermission?.excelIsDisabled || false}
                    variant="contained"
                    onClick={(event) => handleExcelDownloadEmit(event)}
                    endIcon={<SaveAltIcon className="!scale-[0.9]" />}
                  >
                    Excel
                  </Button>
                ) : null}
                {buttonShowPermission?.addItem ? (
                  <Button
                    className="!mr-[16px] "
                    sx={buttonStyle3}
                    style={{
                      backgroundColor: theme.palette.primary.dark,
                      color: 'rgba(255, 255, 255, 1)',
                    }}
                    onClick={(event) => handleOnAddEmit('add')}
                    variant="contained"
                    startIcon={<AddIcon />}
                  >
                    ADD
                  </Button>
                ) : null}

                {buttonShowPermission?.menu ? (
                  <HeaderDropDownMenu
                    menuButtonName={menuButtonName}
                    menus={menus}
                    onSelectMenu={(menu) => handleOnSelectEmit && handleOnSelectEmit(menu)}
                  />
                ) : null}
              </div>
            </Stack>
          )}
        </header>
      </div>
    </>
  );
}
